import React from 'react'
import { domainConverter } from '../../util/util'

export const CardSection = React.memo(({ appData:{customerdata, storedata, affiliationdata}, googleAnalytics  }) => {

	const underclassmenEssentialsData = customerdata?.filter(data => data.contentType === "SchoolStoreUnderclassmenEssentials")[0]
	const hasUnderclassmenEssentialsCardBanner =  Boolean(underclassmenEssentialsData && storedata?.schoolStoreRingSizer?.hasUnderclassmenEssentialsBanner)
	const promoCardsData = customerdata?.filter(data => data.contentType === "PromoCards")[0]
	const hasBeltBucklesProducts = storedata.productCatalogs.some(catalog => catalog.hasBeltBuckle)
	const hasBeltBucklesCardBanner = Boolean(promoCardsData && hasBeltBucklesProducts)
	const tryOnData = customerdata?.filter(data => data.contentType === "SchoolStoreTryOn")[0]
	const hasTryOnCardBanner = Boolean(storedata?.schoolStoreTryOn?.tryOnBannerUrl && tryOnData && !hasBeltBucklesCardBanner)
	
	if ( hasTryOnCardBanner || hasUnderclassmenEssentialsCardBanner || hasBeltBucklesCardBanner ) {
		const totalCards = [hasUnderclassmenEssentialsCardBanner, hasBeltBucklesCardBanner, hasTryOnCardBanner].filter(Boolean).length
		const containerClass = totalCards > 1 ? ` items-${totalCards}` : ""

		const gaTrackingElementClassName = googleAnalytics ? 'jos-ga-tracking-element' : ''
		
		return (
			<div className={`container card-section${containerClass}`}>
				{ hasBeltBucklesCardBanner && 
					<div className="item">
						<div className="img-wrapper">
							<div className="bg"></div>
							<img src={domainConverter(promoCardsData?.imageUrl)} alt={promoCardsData?.imageAltText} loading="lazy" />
						</div>
						<div className="content">
							<h4>{promoCardsData.title}</h4>
							<div className="text" dangerouslySetInnerHTML={{__html: promoCardsData.content}}></div>
							<div>
								<a href={promoCardsData.actionLink} target="_blank" 
									className={`btn btn-primary btn-primary--ghost ${gaTrackingElementClassName}`} rel="noopener noreferrer"
									data-jos-ga-tracking={JSON.stringify({
										_overrideFields: {
											businessUnit: promoCardsData?.gaBaseDataMap?.businessUnit || {},
											productLine: promoCardsData?.gaBaseDataMap?.productLine || {}
										},
										clickText: 'Shop Now', 
										modalType: '', 
										itemName: promoCardsData.title, 
										actionType: 'button_click', 
										contentType: 'PromoCards',
										categoryName: '',
										contentName: promoCardsData.title
									})}
								>Shop Now</a>
							</div>
						</div>
					</div>
				}
				{ hasUnderclassmenEssentialsCardBanner && 
					<div className="item">
						<div className="img-wrapper">
							<div className="bg"></div>
							<img src={domainConverter(underclassmenEssentialsData?.imageUrl)} alt={underclassmenEssentialsData?.imageAltText} loading="lazy" />
						</div>
						<div className="content">
							<h4>{underclassmenEssentialsData.title}</h4>
							<div className="text" dangerouslySetInnerHTML={{__html: underclassmenEssentialsData.content}}></div>
							<div>
								<a href="/products/high-school" target="_blank" 
									className={`btn btn-primary btn-primary--ghost ${gaTrackingElementClassName}`} rel="noopener noreferrer"
									data-jos-ga-tracking={JSON.stringify({
										_overrideFields: {
											businessUnit: underclassmenEssentialsData?.gaBaseDataMap?.businessUnit || {},
											productLine: underclassmenEssentialsData?.gaBaseDataMap?.productLine || {}
										},
										clickText: 'Shop Now', 
										modalType: '', 
										itemName: underclassmenEssentialsData.title, 
										actionType: 'button_click', 
										contentType: 'PromoCards',
										categoryName: '',
										contentName: underclassmenEssentialsData.title
									})}
								>Shop Now</a>
							</div>
						</div>
					</div>
				}
				{ hasTryOnCardBanner && 
					<div className="item">
						<div className="img-wrapper">
							<div className="bg"></div>
							<img src={domainConverter(tryOnData.imageUrl)} alt={tryOnData?.imageAltText} loading="lazy" />
						</div>
						<div className="content">
							<h4>{tryOnData.title}</h4>
							<div className="text" dangerouslySetInnerHTML={{__html: tryOnData.content}}></div>
							<div>
								<a href={storedata.schoolStoreTryOn.tryOnBannerUrl} target="_blank" rel="noopener noreferrer" 
									className={`btn btn-primary btn-primary--ghost ${gaTrackingElementClassName}`}
									data-jos-ga-tracking={JSON.stringify({
										_overrideFields: {
											businessUnit: tryOnData?.gaBaseDataMap?.businessUnit || {},
											productLine: tryOnData?.gaBaseDataMap?.productLine || {}
										},
										clickText: 'CHECK IT OUT', 
										modalType: '', 
										itemName: tryOnData.title, 
										actionType: 'button_click', 
										contentType: 'PromoCards',
										categoryName: '',
										contentName: tryOnData.title
									})}
								>CHECK IT OUT</a>
							</div>
						</div>
					</div>
				}
			</div>
		)
	} else {
		return null
	}
})

// export default React.memo()